import React from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Grid
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import { useDispatch } from 'react-redux';
import {
  uploadOrderImages,
  updateOrderInList,
  getListOrders
} from 'src/features/orderSlice';

const GalleryModal = ({
  openImageModal,
  setOpenImageModal,
  orderForImage,
  setOrderForImage,
  selectedImages,
  setSelectedImages,
  selectedGallery,
  setSelectedGallery,
  deletingImage,
  setDeletingImage,
  handleDeleteImage,
  page,
  PAGE_SIZE
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Dialog
        open={openImageModal}
        onClose={() => {
          setOpenImageModal(false);
          setOrderForImage(null);
          setSelectedImages([]);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle disableTypography style={{ padding: '16px 24px' }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Tải ảnh chụp lắp đặt
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ backgroundColor: '#fcfcfd' }}>
          <Box
            p={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="raised-button-file"
              multiple
              type="file"
              onChange={e => {
                const files = Array.from(e.target.files);
                setSelectedImages([...selectedImages, ...files]);
              }}
            />
            <label htmlFor="raised-button-file" style={{ width: '100%' }}>
              <Button
                variant="outlined"
                component="span"
                fullWidth
                startIcon={<PhotoCameraIcon />}
                style={{
                  height: 100,
                  border: '2px dashed #3f51b5',
                  borderRadius: 16,
                  color: '#3f51b5',
                  fontWeight: 600,
                  fontSize: 15,
                  textTransform: 'none',
                  backgroundColor: '#e8f0fe33'
                }}
              >
                Chọn ảnh chụp thực tế
              </Button>
            </label>

            <Box mt={3} width="100%">
              <Grid container spacing={1}>
                {selectedImages.map((file, i) => (
                  <Grid item xs={4} key={i}>
                    <Box
                      position="relative"
                      style={{
                        paddingTop: '75%',
                        borderRadius: 8,
                        overflow: 'hidden',
                        border: '1px solid #eee'
                      }}
                    >
                      <img
                        src={URL.createObjectURL(file)}
                        alt="preview"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                      <IconButton
                        size="small"
                        onClick={() =>
                          setSelectedImages(
                            selectedImages.filter((_, idx) => idx !== i)
                          )
                        }
                        style={{
                          position: 'absolute',
                          top: 4,
                          right: 4,
                          backgroundColor: 'rgba(255,255,255,0.9)',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                      >
                        <DeleteIcon style={{ fontSize: 16, color: '#f44336' }} />
                      </IconButton>
                    </Box>
                  </Grid>
                ))}
                {selectedImages.length === 0 && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width="100%"
                    py={6}
                    style={{
                      border: '2px dashed #e0e3ef',
                      borderRadius: 16,
                      backgroundColor: '#f8f9fc'
                    }}
                  >
                    <Typography style={{ color: '#8898aa', fontWeight: 500 }}>
                      Chưa có ảnh nào được chọn
                    </Typography>
                    <Typography
                      variant="caption"
                      style={{ color: '#adb5bd', marginTop: 4 }}
                    >
                      Tải ảnh
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            onClick={() => {
              setOpenImageModal(false);
              setOrderForImage(null);
              setSelectedImages([]);
            }}
            color="default"
            style={{ textTransform: 'none', fontWeight: 600 }}
          >
            Hủy
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={selectedImages.length === 0}
            onClick={() => {
              dispatch(
                uploadOrderImages({
                  id: orderForImage.id,
                  images: selectedImages
                })
              ).then(res => {
                if (res.meta.requestStatus === 'fulfilled') {
                  const result = res.payload?.payload || res.payload;
                  if (result?.order_images || result?.orderImages) {
                    dispatch(
                      updateOrderInList({
                        id: orderForImage.id,
                        data: {
                          order_images:
                            result.order_images || result.orderImages
                        }
                      })
                    );
                  } else {
                    dispatch(
                      getListOrders({
                        page,
                        page_size: PAGE_SIZE
                      })
                    );
                  }
                  setOpenImageModal(false);
                  setOrderForImage(null);
                  setSelectedImages([]);
                }
              });
            }}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              padding: '8px 32px',
              borderRadius: 8
            }}
          >
            Tải ảnh lên
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Xem Ảnh Dạng Gallery ── */}
      <Dialog
        open={Boolean(selectedGallery)}
        onClose={() => setSelectedGallery(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            overflow: 'visible'
          }
        }}
      >
        {selectedGallery && (
          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            {selectedGallery.order_status < 4 &&
              selectedGallery.order_status !== -1 && (
                <IconButton
                  onClick={() =>
                    setDeletingImage(
                      selectedGallery.images[selectedGallery.index]
                    )
                  }
                  style={{
                    position: 'absolute',
                    top: -40,
                    left: 0,
                    color: '#ff4d4f'
                  }}
                >
                  <DeleteIcon style={{ fontSize: 32 }} />
                </IconButton>
              )}
            <IconButton
              onClick={() => setSelectedGallery(null)}
              style={{
                position: 'absolute',
                top: -40,
                right: 0,
                color: 'white'
              }}
            >
              <CloseIcon style={{ fontSize: 32 }} />
            </IconButton>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              style={{ minHeight: '60vh' }}
            >
              <IconButton
                disabled={selectedGallery.index === 0}
                onClick={() =>
                  setSelectedGallery({
                    ...selectedGallery,
                    index: selectedGallery.index - 1
                  })
                }
                style={{
                  color: 'white',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  marginRight: 20
                }}
              >
                <ChevronLeftIcon fontSize="large" />
              </IconButton>

              <img
                src={`${process.env.REACT_APP_IMG_SERVER}/${
                  selectedGallery.images[selectedGallery.index].url
                }`}
                alt="gallery"
                style={{
                  maxWidth: '80%',
                  maxHeight: '80vh',
                  borderRadius: 8,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.5)'
                }}
              />

              <IconButton
                disabled={
                  selectedGallery.index === selectedGallery.images.length - 1
                }
                onClick={() =>
                  setSelectedGallery({
                    ...selectedGallery,
                    index: selectedGallery.index + 1
                  })
                }
                style={{
                  color: 'white',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  marginLeft: 20
                }}
              >
                <ChevronRightIcon fontSize="large" />
              </IconButton>
            </Box>

            <Box
              mt={2}
              display="flex"
              gap={1}
              flexWrap="wrap"
              justifyContent="center"
            >
              {selectedGallery.images.map((img, i) => (
                <Box
                  key={i}
                  onClick={() =>
                    setSelectedGallery({ ...selectedGallery, index: i })
                  }
                  style={{
                    width: 50,
                    height: 50,
                    borderRadius: 4,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    border:
                      i === selectedGallery.index
                        ? '2px solid white'
                        : '2px solid transparent',
                    opacity: i === selectedGallery.index ? 1 : 0.6,
                    transition: '0.3s'
                  }}
                >
                  <img
                    src={`${process.env.REACT_APP_IMG_SERVER}/${img.url}`}
                    alt="thumb"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Dialog>

      {/* ── Confirm Delete Image ── */}
      <Dialog
        open={Boolean(deletingImage)}
        onClose={() => setDeletingImage(null)}
      >
        <DialogTitle>Xác nhận xóa ảnh</DialogTitle>
        <DialogContent>
          Bạn có chắc chắn muốn xóa ảnh này không?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeletingImage(null)}>Hủy</Button>
          <Button
            onClick={handleDeleteImage}
            color="secondary"
            variant="contained"
          >
            Xóa
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GalleryModal;
